import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const ASSETMANAGER_REQUEST = 'ASSETMANAGER_REQUEST';
export const ASSETMANAGER_SUCCESS = 'ASSETMANAGER_SUCCESS';
export const ASSETMANAGER_FAILURE = 'ASSETMANAGER_FAILURE';

export const ASSET_DETAILS_REQUEST = 'ASSET_DETAILS_REQUEST';
export const ASSET_DETAILS_SUCCESS = 'ASSET_DETAILS_SUCCESS';
export const ASSET_DETAILS_FAILURE = 'ASSET_DETAILS_FAILURE';

export const ASSET_UPDATE_REQUEST = 'ASSET_UPDATE_REQUEST';
export const ASSET_UPDATE_SUCCESS = 'ASSET_UPDATE_SUCCESS';
export const ASSET_UPDATE_FAILURE = 'ASSET_UPDATE_FAILURE';

export const ASSET_TYPES_REQUEST = 'ASSET_TYPES_REQUEST';
export const ASSET_TYPES_SUCCESS = 'ASSET_TYPES_SUCCESS';
export const ASSET_TYPES_FAILURE = 'ASSET_TYPES_FAILURE';

export const ASSET_OWNER_TYPES_REQUEST = 'ASSET_OWNER_TYPES_REQUEST';
export const ASSET_OWNER_TYPES_SUCCESS = 'ASSET_OWNER_TYPES_SUCCESS';
export const ASSET_OWNER_TYPES_FAILURE = 'ASSET_OWNER_TYPES_FAILURE';

export const CLIENT_ASSETS_REQUEST = 'CLIENT_ASSETS_REQUEST';
export const CLIENT_ASSETS_SUCCESS = 'CLIENT_ASSETS_SUCCESS';
export const CLIENT_ASSETS_FAILURE = 'CLIENT_ASSETS_FAILURE';

export const LOCATION_ASSETS_REQUEST = 'LOCATION_ASSETS_REQUEST';
export const LOCATION_ASSETS_SUCCESS = 'LOCATION_ASSETS_SUCCESS';
export const LOCATION_ASSETS_FAILURE = 'LOCATION_ASSETS_FAILURE';

export const ASSET_CATEGORIES_REQUEST = 'ASSET_CATEGORIES_REQUEST';
export const ASSET_CATEGORIES_SUCCESS = 'ASSET_CATEGORIES_SUCCESS';
export const ASSET_CATEGORIES_FAILURE = 'ASSET_CATEGORIES_FAILURE';

export const ASSET_STATUSES_REQUEST = 'ASSET_STATUSES_REQUEST';
export const ASSET_STATUSES_SUCCESS = 'ASSET_STATUSES_SUCCESS';
export const ASSET_STATUSES_FAILURE = 'ASSET_STATUSES_FAILURE';

export function requestAssets(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/asset/search?${query}`,
      method: 'GET',
      types: ['ASSETMANAGER_REQUEST', 'ASSETMANAGER_SUCCESS', 'ASSETMANAGER_FAILURE']
    }
  };
}

export function requestAssetDetails(assetId, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/asset/${assetId}?${query}`,
      method: 'GET',
      types: [
        { type: 'ASSET_DETAILS_REQUEST', meta: { assetId } },
        { type: 'ASSET_DETAILS_SUCCESS', meta: { assetId } },
        { type: 'ASSET_DETAILS_FAILURE', meta: { assetId } },
      ]
    }
  }
}

export function updateAssetDetails(asset, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/asset?${query}`,
      method: 'POST',
      body: JSON.stringify(asset),
      types: ["ASSET_UPDATE_REQUEST", "ASSET_UPDATE_SUCCESS", "ASSET_UPDATE_FAILURE"]
    }
  }
}

export function requestAssetTypes(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/asset-types/all?${query}`,
      method: 'GET',
      types: ['ASSET_TYPES_REQUEST', 'ASSET_TYPES_SUCCESS', 'ASSET_TYPES_FAILURE',]
    }
  }
}

export function requestAssetTypesByCategoryId(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/asset-types?${query}`,
      method: 'GET',
      types: ['ASSET_TYPES_CAT_REQUEST', 'ASSET_TYPES_CAT_SUCCESS', 'ASSET_TYPES_CAT_FAILURE',]
    }
  }
}

export function requestAssetOwnerTypes(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/asset-owner-types/all?${query}`,
      method: 'GET',
      types: ['ASSET_OWNER_TYPES_REQUEST', 'ASSET_OWNER_TYPES_SUCCESS', 'ASSET_OWNER_TYPES_FAILURE',]
    }
  }
}

export function requestAssetCategories(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/asset-categories/all?${query}`,
      method: 'GET',
      types: ['ASSET_CATEGORIES_REQUEST', 'ASSET_CATEGORIES_SUCCESS', 'ASSET_CATEGORIES_FAILURE',]
    }
  }
}

export function importData(params, htmlFiles = []) {
  const query = $.param(params);
  const data = new FormData();

  htmlFiles.forEach((file) => data.append('files', file));

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/assets/import/files?${query}`,
      method: 'POST',
      headers: {},
      body: data,
      types: ['IMPORT_REQUEST', 'IMPORT_SUCCESS', 'IMPORT_FAILURE']
    },
  };
}

export function requestAssetStatuses(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/asset-statuses/all?${query}`,
      method: 'GET',
      types: ['ASSET_STATUSES_REQUEST', 'ASSET_STATUSES_SUCCESS', 'ASSET_STATUSES_FAILURE',]
    }
  }
}

export function deleteAsset(assetId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/asset/delete/${assetId}?${query}`,
      method: 'DELETE',
      body: JSON.stringify(assetId),
      types: ["ASSET_DELETE_REQUEST", "ASSET_DELETE_SUCCESS", "ASSET_DELETE_FAILURE"]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/asset-manager/AssetManagerActions.js